/**
 * バリデーションクラス名と対応するCSSクラス名のマッピング
 * @constant {object} validationClasses
 */
const validationClasses = {
    formArea: 'check_form-area',
    formUpload: 'check_form-upload',
    required: 'check_required',
    realTime: 'check_real-time',
    anyRequired: 'check_any_required',
    tel: 'check_tel',
    mail: 'check_mail',
    num: 'check_num',
    alphabet: 'check_alphabet',
    alphaNum: 'check_alpha_num',
    zip: 'check_zip',
    kana: 'check_kana',
    hiragana: 'check_hiragana',
    katakana: 'check_katakana',
    file: 'check_file',
    btnSubmit: 'check_submit',
    noInput: 'box_cmn_form_no-input check_no-through',
    err: 'val-err',
    addrErr: 'addr-err',
    through: 'val-through',
};
export default validationClasses;
//# sourceMappingURL=validationClasses.js.map